export const OnewaySearchIdQueryTab = {
  HeaderTable: ["Parameter", "Value", "Required", "Example"],
  HeaderBodyTable: [
    {
      Parameter: "email",
      Value: "String",
      Required: "true",
      Example: "abc@email.com (Enter the given Login Email)",
    },
  ],
}

export const OnewaySearchIdBodyTab = {
  HeaderTable: ["Parameter", "Value", "Required", "Example"],
  HeaderBodyTable: [
    {
      Parameter: "BookingDetails.sourceLat",
      Value: "String",
      Required: "true",
      Example: "13.73925",
    },
    {
      Parameter: "BookingDetails.sourceLng",
      Value: "String",
      Required: "true",
      Example: "100.557801",
    },
    {
      Parameter: "BookingDetails.destinationLat",
      Value: "String",
      Required: "true",
      Example: "-0.17033904790878",
    },
    {
      Parameter: "BookingDetails.destinationLng",
      Value: "String",
      Required: "true",
      Example: "51.519360236934",
    },
    {
      Parameter: "BookingDetails.sourcePlaceName",
      Value: "String",
      Required: "true",
      Example: "London Heathrow International Airport (LHR)",
    },
    {
      Parameter: "BookingDetails.destinationPlaceName",
      Value: "String",
      Required: "true",
      Example: "Hilton London Metropole",
    },
    {
      Parameter: "BookingDetails.date",
      Value: "String",
      Required: "true",
      Example: "2024-08-15",
    },
    {
      Parameter: "BookingDetails.time",
      Value: "String",
      Required: "true",
      Example: "10:00",
    },
    {
      Parameter: "BookingDetails.passenger",
      Value: "String",
      Required: "true",
      Example: "1",
    },    
  ],
};

export const OnewayVehicleWithPriceQueryTab = {
  HeaderTable: ["Parameter", "Value", "Required", "Example"],
  HeaderBodyTable: [
    {
      Parameter: "email",
      Value: "String",
      Required: "true",
      Example: "abc@email.com (Enter the given Login Email)",
    },
    {
        Parameter: "searchId",
        Value: "String",
        Required: "true",
        Example: "SE-0824-X7OU0-OW",
      },
  ],
};


export const OnewayBookingWithVehicleQueryTab = {
  HeaderTable: ["Parameter", "Value", "Required", "Example"],
  HeaderBodyTable: [
    {
      Parameter: "email",
      Value: "String",
      Required: "true",
      Example: "abc@email.com (Enter the given Login Email)",
    },
    {
        Parameter: "searchId",
        Value: "String",
        Required: "true",
        Example: "SE-0824-X7OU0-OW",
      },
  ],
};


export const OnewayBookingWithVehicleBodyTab = {
  HeaderTable: ["Parameter", "Value", "Required", "Example"],
  HeaderBodyTable: [
    {
      Parameter: "vehicleId",
      Value: "String",
      Required: "true",
      Example: "6426d4fd7cfcc6b82fc1c24e",
    },
    {
      Parameter: "passengerDetails.firstname",
      Value: "String",
      Required: "true",
      Example: "test firstname",
    },
    {
      Parameter: "passengerDetails.lastname",
      Value: "String",
      Required: "true",
      Example: "test lastname",
    },
    {
      Parameter: "passengerDetails.email",
      Value: "String",
      Required: "true",
      Example: "appdocstest@email.com",
    },
    {
      Parameter: "passengerDetails.phone",
      Value: "String",
      Required: "true",
      Example: "6589455236",
    },
    {
      Parameter: "passengerDetails.country",
      Value: "String",
      Required: "true",
      Example: "India",
    },
    {
      Parameter: "passengerDetails.dial_code",
      Value: "String",
      Required: "true",
      Example: "+91",
    },
    {
      Parameter: "passengerDetails.flightOrTrain",
      Value: "String",
      Required: "true",
      Example: "TK1372",
    },
    {
      Parameter: "passengerDetails.reference",
      Value: "String",
      Required: "true",
      Example: "9978556897844",
    },
    {
      Parameter: "passengerDetails.specialRequest",
      Value: "String",
      Required: "true",
      Example: "no special request / any special request",
    }
  ],
};




